import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IApplicationInfo } from '~/types/application-info'

import { getApplicationMetadata } from '~/api/application-metadata'

////////// KEYS //////////

export const keys = {
  all: ['application-metadata'] as const,
  details: (appKey?: string) => [...keys.all, 'details', appKey] as const,
}

////////// QUERIES //////////

export const useGetApplicationMetadataQuery = (appKey?: string): UseQueryResult<IApplicationInfo> => {
  return useQuery({
    enabled: !!appKey,
    queryFn: () => getApplicationMetadata(appKey),
    queryKey: keys.details(appKey),
  })
}
